import styled from 'styled-components'

export const StyledSearchBarWrapper = styled.div`
    display: flex;
    flex: 1;
    padding: 8px 32px;
    background-color: #f5f5f5;
    position: sticky;
    top: 0;
    z-index: 1;
`
